import { TextRegular } from 'UiKit/typography';

import ColumnAccount from 'View/report/component/columnAccount';

import styles from './styles.module.css';

const tableListAccountPlatform = ({ t }) => [
  {
    name: t('table.common.account'),
    key: 'account',
    width: 180,
    leftSticky: 0,
    sortKey: 'accountName',
    component: ({ value }) => <ColumnAccount values={value} />,
  },
  {
    name: t('table.common.gmv'),
    width: 200,
    key: 'totalGmv',
    sortKey: 'totalGmv',
    labelInfo: t('table.common.tooltipGmv'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.err'),
    width: 150,
    key: 'totalErrPercentage',
    sortKey: 'totalErrPercentage',
    labelInfo: t('table.common.tooltipErr'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.ctr'),
    width: 150,
    key: 'totalCtrPercentage',
    sortKey: 'totalCtrPercentage',
    labelInfo: t('table.common.tooltipCtr'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.ctor'),
    width: 150,
    key: 'totalConversationRate',
    sortKey: 'totalConversationRate',
    labelInfo: t('table.common.tooltipCtor'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.aov'),
    width: 200,
    key: 'totalAov',
    sortKey: 'totalAov',
    labelInfo: t('table.common.tooltipAov'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.shareRate'),
    width: 200,
    key: 'totalShareNumbers',
    sortKey: 'totalShareNumbers',
    labelInfo: t('table.common.tooltipShareRate'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.commentRate'),
    width: 200,
    key: 'totalCommentNumbers',
    sortKey: 'totalCommentNumbers',
    labelInfo: t('table.common.tooltipCommentRate'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.newFollowers'),
    width: 200,
    key: 'totalNewFollowers',
    sortKey: 'totalNewFollowers',
    labelInfo: t('table.common.tooltipNewFollowers'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.likesRate'),
    width: 200,
    key: 'totalLikeNumbers',
    sortKey: 'totalLikeNumbers',
    labelInfo: t('table.common.tooltipLikesRate'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.impressions'),
    width: 150,
    key: 'totalImpressions',
    sortKey: 'totalImpressions',
    labelInfo: t('table.common.tooltipImpressions'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.totalLiveDuration'),
    width: 190,
    key: 'totalLiveDuration',
    sortKey: 'totalLiveDuration',
    labelInfo: t('table.common.tooltipTotalLiveDuration'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.views'),
    width: 150,
    key: 'totalViews',
    sortKey: 'totalViews',
    labelInfo: t('table.common.tooltipViews'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.viewers'),
    width: 150,
    key: 'totalViewers',
    sortKey: 'totalViewers',
    labelInfo: t('table.common.tooltipViewers'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.awd'),
    width: 270,
    key: 'totalAwd',
    sortKey: 'totalAwd',
    labelInfo: t('table.common.tooltipAwd'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
];

export default tableListAccountPlatform;